import apiClient from "./apiClient";

export const listPortfolioItems = async ({ search = "", categoryId = "", featured = "", page = 1 } = {}) => {
  const { data } = await apiClient.get("/portfolio-items", {
    params: {
      search: search || undefined,
      category_id: categoryId || undefined,
      featured: featured === "" ? undefined : featured,
      page,
    },
  });
  return { items: data.data, pagination: data.meta.pagination };
};

export const createPortfolioItem = async (payload) => {
  const { data } = await apiClient.post("/portfolio-items", payload);
  return data.data;
};

export const updatePortfolioItem = async (id, payload) => {
  const { data } = await apiClient.put(`/portfolio-items/${id}`, payload);
  return data.data;
};

export const deletePortfolioItem = async (id) => {
  await apiClient.delete(`/portfolio-items/${id}`);
};
